import { ListColumn } from '@core/models/common/list-column';
import { DeliveryOrderColumnId } from './delivery-orders-column-id';

export const DELIVERY_ORDERS_COLUMNS: ListColumn[] = [
    {
        id: DeliveryOrderColumnId.ORDER,
        label: DeliveryOrderColumnId.ORDER,
    },
    {
        id: DeliveryOrderColumnId.STATUS,
        label: DeliveryOrderColumnId.STATUS,
    },
    {
        id: DeliveryOrderColumnId.CUSTOMER,
        label: DeliveryOrderColumnId.CUSTOMER,
    },
    {
        id: DeliveryOrderColumnId.ORDERED,
        label: DeliveryOrderColumnId.ORDERED,
    },
    {
        id: DeliveryOrderColumnId.TOTAL,
        label: DeliveryOrderColumnId.TOTAL,
    },
    {
        id: DeliveryOrderColumnId.SERVICE_PROVIDER,
        label: DeliveryOrderColumnId.SERVICE_PROVIDER,
    },
    {
        id: DeliveryOrderColumnId.PICKUP_FROM,
        label: DeliveryOrderColumnId.PICKUP_FROM,
    },
    {
        id: DeliveryOrderColumnId.PICKUP,
        label: DeliveryOrderColumnId.PICKUP,
    },
    {
        id: DeliveryOrderColumnId.DROPOFF,
        label: DeliveryOrderColumnId.DROPOFF,
    },
    {
        id: DeliveryOrderColumnId.WARNING,
        label: '', // no label to show
    },
    {
        id: DeliveryOrderColumnId.MANAGER_NOTES,
        label: '', // no label to show
    },
    // {
    //     id: DeliveryOrderColumnId.DISTANCE,
    //     label: DeliveryOrderColumnId.DISTANCE,
    // },
    // {
    //     id: DeliveryOrderColumnId.DRIVER,
    //     label: DeliveryOrderColumnId.DRIVER,
    // },
];